import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getBackendBaseUrl } from "../../../../shared/api/backendDiscovery";

const CONTACT_EMAIL = "andremourapassos@gmail.com";
const CONTACT_SUBJECT = "Contato pelo Portfólio";

export default function ContactWindowContent() {
  const { t, i18n } = useTranslation("aiPortfolio");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    interests: [],
  });
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState("");

  const interestOptions = useMemo(
    () => [
      { id: "hire", label: t("contactForm.interests.hire") },
      { id: "idea", label: t("contactForm.interests.idea") },
    ],
    [t]
  );

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleToggleInterest = (interestId) => {
    setFormData((current) => {
      const isSelected = current.interests.includes(interestId);
      return {
        ...current,
        interests: isSelected
          ? current.interests.filter((value) => value !== interestId)
          : [...current.interests, interestId],
      };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("");
    setIsSending(true);

    const selectedInterests = interestOptions
      .filter((option) => formData.interests.includes(option.id))
      .map((option) => option.label);
    const interestLine =
      selectedInterests.length > 0
        ? selectedInterests.join(", ")
        : t("contactForm.interests.none");
    const formattedMessage = `${formData.message}\n\n${t("contactForm.interestsLabel")}: ${interestLine}\n${t(
      "contactForm.subjectLabel"
    )}: ${CONTACT_SUBJECT}`;

    try {
      const apiBaseUrl = await getBackendBaseUrl();
      const response = await fetch(`${apiBaseUrl}/api/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formattedMessage,
          subject: CONTACT_SUBJECT,
          lang: i18n.language,
        }),
      });

      const data = await response.json();
      if (response.ok && data.success) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "", interests: [] });
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="contactWindowContent">
      <p className="resumeWindowTitle">{t("contactForm.title")}</p>
      <p>{t("contactForm.description")}</p>

      <form className="contactWindowForm" onSubmit={handleSubmit}>
        <label htmlFor="portfolio-contact-name">{t("contactForm.name")}</label>
        <input
          id="portfolio-contact-name"
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="portfolio-contact-email">{t("contactForm.email")}</label>
        <input
          id="portfolio-contact-email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="portfolio-contact-message">{t("contactForm.message")}</label>
        <textarea
          id="portfolio-contact-message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows={6}
          required
        />

        <fieldset className="contactWindowFieldset">
          <legend>{t("contactForm.interestsLabel")}</legend>
          {interestOptions.map((option) => (
            <label key={option.id} className="contactWindowCheckbox">
              <input
                type="checkbox"
                checked={formData.interests.includes(option.id)}
                onChange={() => handleToggleInterest(option.id)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </fieldset>

        <button type="submit" disabled={isSending}>
          {isSending
            ? t("contactForm.sending")
            : status === "success"
            ? t("contactForm.success")
            : status === "error"
            ? t("contactForm.error")
            : t("contactForm.send")}
        </button>
      </form>

      <p className="contactWindowDirectEmail">
        <strong>{t("contactForm.directEmailLabel")}</strong>{" "}
        <a href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(CONTACT_SUBJECT)}`}>{CONTACT_EMAIL}</a>
      </p>
    </div>
  );
}
